import React, { useEffect, useState } from "react";
import "./style.css";
import logo from "assets/images/headerimage.jpg";
import logotext from "assets/images/dmrlogo.png";
import rotatingImage from 'assets/images/sun.png';
import { FaFacebook } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { FaSquareYoutube } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";

export default function Header() {
  const [currentDate, setCurrentDate] = useState("");
  const getCurrentDateAndTime = () => {
    const date = new Date();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight
    if (hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes <= 9) {
      minutes = "0" + minutes;
    }
    // Format minutes to always be two digits
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return months[date.getMonth() - 1] + "," + date.getDate() + " " + date.getFullYear() + ", " + hours + ":" + minutes + " " + ampm;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(getCurrentDateAndTime());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <>
      <section className="header-top">
        <div className="time">
          <label>
            {currentDate} &nbsp; &nbsp;
            <a href="https://www.facebook.com/DattamandirRuibhar/" target="_blank" rel="noopener noreferrer">
              <FaFacebook style={{color:"white"}}/>
            </a>
            &nbsp;
            <a href="https://www.youtube.com/@ShrishetraDattaMandirRuibhar" target="_blank" rel="noopener noreferrer">
              <FaSquareYoutube style={{color:"white"}} />
            </a>
          </label>
          <label style={{ position: "absolute", right: "20px" }}>
            <FaMobileAlt /> 9422070407
          </label>
        </div>
      </section>
      <header>
        <a href="/" class="logo">
          <img className="rotatingimage" src={rotatingImage} alt="" />
          <img src={logo} alt="" />
          <div className="logo-text">
            <img src={logotext} alt="" />
            {/* ॐ || श्री दत्त मंदिर संस्थान श्री क्षेत्र रुईभर || 卐 */}
          </div>
        </a>
        <input type="checkbox" id="menu-bar" />
        <label htmlFor="menu-bar">
          <FaBars />
        </label>
        <nav class="navbar">
          <ul>
            <li>
              <a href="/">मुख्य पृष्ठ</a>
            </li>

            {/* <li>
              <a href="#">Pages +</a>
              <ul>
                <li>
                  <a href="#">blogs</a>
                </li>
                <li>
                  <a href="#">Services +</a>
                  <ul>
                    <li>
                      <a href="#">HTML</a>
                    </li>
                    <li>
                      <a href="#">CSS</a>
                    </li>
                    <li>
                      <a href="#">JAVASCRIPT</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">Review</a>
            </li>
            <li>
              <a href="#">Gallery +</a>
              <ul>
                <li>
                  <a href="#">grid gallery</a>
                </li>
                <li>
                  <a href="#">flex gallery</a>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="/babaji">बाबाजी</a>
            </li>
            <li>
              <a href="/pranpratisthapana">प्राणप्रतिष्टा</a>
            </li>
            <li>
              <a href="/donation">देणगी</a>
            </li>
            
            <li>
              <a href="/dharmik-sankalpana">धार्मिक संकल्प</a>
            </li>
            <li>
              <a href="/contact-us">संपर्क</a>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}
